import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FilterCacheService {
  private cache = new Map<string, any>();

  set(key: string, filters: any): void {
    const dataToSave = { ...filters };

    // 1. Guardar en memoria
    this.cache.set(key, dataToSave);

    // 2. Guardar en sessionStorage de forma independiente usando su propia key
    sessionStorage.setItem(key, JSON.stringify(dataToSave));
  }

  get<T>(key: string): T | null {
    // 1. Buscar primero en la memoria RAM (Map)
    if (this.cache.has(key)) {
      return this.cache.get(key) as T;
    }

    // 2. Si se presionó F5, la memoria se borra. Buscamos el respaldo en sessionStorage usando la key
    const stored = sessionStorage.getItem(key);
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        this.cache.set(key, parsed); // Restaurar en memoria para las siguientes consultas
        return parsed as T;
      } catch (e) {
        console.error(`Error parseando la cache de filtros para la llave: ${key}`, e);
      }
    }

    return null;
  }

  clear(key: string): void {
    // Limpiar tanto de memoria como de sessionStorage usando la key enviada
    this.cache.delete(key);
    sessionStorage.removeItem(key);
  }

  clearAll(): void {
    // Iterar sobre el Map para limpiar el sessionStorage de las llaves conocidas
    this.cache.forEach((_, key) => {
      sessionStorage.removeItem(key);
    });
    this.cache.clear();
  }
}
